import React, { useEffect, useState } from "react";
import BtnLoad from "../../components/common/BtnLoad";
import { CheckForPublish } from "../../assets/icons/icons";

const steps = [
  { name: "Starting", order: 1 },
  { name: "Processing", order: 2 },
  { name: "Complete", order: 3 },
];

const PublishLoad = ({ progressComplete = false, progressFailed = false }) => {
  const [currentStep, setCurrentStep] = useState(1);
  const [finalComplete, setFinalComplete] = useState(false);

  useEffect(() => {
    let timer;

    if (currentStep === 1) {
      timer = setTimeout(() => setCurrentStep(2), 2000);
    } else if (currentStep === 2 && progressComplete) {
      timer = setTimeout(() => setCurrentStep(3), 2000);
    } else if (currentStep === 3) {
      timer = setTimeout(() => setFinalComplete(true), 2000);
    }

    return () => clearTimeout(timer);
  }, [currentStep, progressComplete]);

  const renderIcon = (stepOrder) => {
    if (stepOrder > currentStep) return <BtnLoad />;
    if (stepOrder < currentStep) {
      return <CheckForPublish />;
    }
    if (stepOrder === 3 && currentStep === 3) {
      return finalComplete ? <CheckForPublish /> : <BtnLoad />;
    }
    if (stepOrder === currentStep) {
      return <BtnLoad />;
    }
    return null;
  };

  const sortedSteps = [
    ...steps.filter((step) => step.order === currentStep),
    ...steps.filter((step) => step.order !== currentStep).sort((a, b) => b.order - a.order),
  ];
  if(finalComplete) return ;
  return (
    <div className="publishOverlay">
      {sortedSteps.map(({ name, order }) => (
        <div className="loadingItem" key={order}> 
          <p>
            {name} {order === currentStep && !finalComplete && <span> ...</span>}
          </p>
          <span className="iconWrapper">{renderIcon(order)}</span>
        </div>
      ))}
    </div>
  );
};

export default PublishLoad;
